@if (dataSource.loading$ | async) {
  <div
    [@fadeIn]="dataSource.loading$ | async"
    [@fadeOut]="dataSource.loading$ | async"
    class="spinner-container-wrapper">
    <div class="spinner-container" >
      <mat-spinner></mat-spinner>
    </div>
  </div>
}

<table mat-table
  [dataSource]="dataSource.data | async"
  class="w-full"
  multiTemplateDataRows
  matSortDisableClear
  matSort>
  @for (col of columnDefinitions; track col) {
    <ng-container [matColumnDef]="col.columnDef">
      @if (col.columnDef === 'expand') {
        <th mat-header-cell  *matHeaderCellDef>{{ col.header }}</th>
      } @else {
        @if (col.sort) {
          <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ col.header }}</th>
        }
        @if (!col.sort) {
          <th mat-header-cell *matHeaderCellDef>{{ col.header }}</th>
        }
      }
      <td mat-cell *matCellDef="let element">
        @if (col.cell) {
          <ng-container *ngTemplateOutlet="col.cell; context: {$implicit: element}"></ng-container>
        } @else {
          @switch (col.columnDef) {
            @case ('expand') {
              @if (element.notes) {
                <button mat-icon-button aria-label="expand row"
                  (click)="(expandedElement = expandedElement === element ? null : element); $event.stopPropagation()">
                  @if (expandedElement !== element) {
                    <mat-icon>keyboard_arrow_down</mat-icon>
                  }
                  @if (expandedElement === element) {
                    <mat-icon>keyboard_arrow_up</mat-icon>
                  }
                </button>
              }
            }
            @case ('id') {
              <div class="whitespace-nowrap last-column">
                <a [routerLink]="'./'+ element.id + '/edit'"
                  (click)="$event.stopPropagation()">
                  <button mat-fab color="primary" class="mr-2">
                    <mat-icon svgIcon="heroicons_outline:pencil"></mat-icon>
                  </button>
                </a>
                <button mat-fab color="warn"
                  (click)="deleteClick(element.id); $event.stopPropagation();">
                  <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                </button>
              </div>
            }
            @default {
              {{ element[col.columnDef] }}
            }
          }
        }
      </td>
    </ng-container>
  }
  <ng-container matColumnDef="expandedDetail">
    <td mat-cell *matCellDef="let element" [attr.colspan]="columnDefinitions.length">
      <div class="td-detail"
        [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
        <div class="td-element-description">
          <table>
            @if (element.notes) {
              <tr>
                <td><b>Notas:</b></td>
                <td class="pl-2">{{element.notes}}</td>
              </tr>
            }
          </table>
        </div>
      </div>
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="columnDefs"></tr>
  <tr mat-row *matRowDef="let element; columns: columnDefs;"
    class="cursor-pointer"
    [class.example-expanded-row]="expandedElement === element">
  </tr>
  <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="tr-detail-row"></tr>
</table>

<mat-paginator
  [pageSizeOptions]="[30, 50, 100]"
  [length]="dataSource.totalItems"
  [pageSize]="defaultPageSize"
  showFirstLastButtons>
</mat-paginator>
